import { render, staticRenderFns } from "./CardDialog.vue?vue&type=template&id=a6aea25a"
import script from "./CardDialog.vue?vue&type=script&lang=js"
export * from "./CardDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports